<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';
import { useAirBulletin } from '../composables/useAirBulletin';
const route = useRoute();
const { previousDesign, isLoading, feedStatus, liveSourceLabel } = useAirBulletin();
</script>

<template>
  <header class="site-header">
    <RouterLink
      class="wordmark"
      :to="{ name: 'home', query: route.query }"
      aria-label="HazePuns home"
    >
      <span class="wordmark-name"
        ><span class="wordmark-text"
          >HazePuns<span class="wordmark-period" aria-hidden="true">.</span></span
        ><small v-if="previousDesign">Air Your Grievances</small></span
      >
    </RouterLink>
    <div
      class="source-status"
      :class="{
        offline: feedStatus === 'stale' || feedStatus === 'unavailable',
        loading: isLoading,
      }"
      role="status"
    >
      <span class="source-dot"></span><span>{{ liveSourceLabel }}</span>
    </div>
  </header>
</template>
